var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.367,2.985h-.333L11.217.169a.589.589,0,0,0-.825,0,.589.589,0,0,0,0,.825l1.992,1.992h-8.1L6.275.994a.589.589,0,0,0,0-.825.589.589,0,0,0-.825,0L2.642,2.985H2.308c-.75,0-2.308,0-2.308,2.133A2.272,2.272,0,0,0,.517,6.81a1.345,1.345,0,0,0,.7.375,3.223,3.223,0,0,0,.75.067H14.7a3.48,3.48,0,0,0,.733-.067c.7-.167,1.233-.667,1.233-2.067C16.667,2.985,15.108,2.985,14.367,2.985Z",
    transform: "translate(1.667 1.665)",
    fill: "#8963f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.653,0H.836A.832.832,0,0,0,.011.967l.7,4.283c.233,1.433.858,3.083,3.633,3.083H9.02c2.808,0,3.308-1.408,3.608-2.983L13.47.992A.83.83,0,0,0,12.653,0ZM6.778,6.25A3.549,3.549,0,0,1,3.236,2.708a.625.625,0,1,1,1.25,0,2.292,2.292,0,0,0,4.583,0,.625.625,0,0,1,1.25,0A3.549,3.549,0,0,1,6.778,6.25Z",
    transform: "translate(3.222 10)",
    fill: "#8963f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetail);
export default __webpack_public_path__ + "static/media/icon-retail.017f7b79ba287e5bb96dfaaf242f4adc.svg";
export { ForwardRef as ReactComponent };